import { gql, useLazyQuery } from '@apollo/client';
import { useState } from 'react';
import JsonViewScreen from '~/components/debug/JsonViewScreen';
import { DriveTimeOptimizerQuery, DriveTimeOptimizerInput } from '~/graphql/__generated__/graphql';
import { DRIVE_TIME_OPTIMIZER_QUERY } from '../command';

export default function DriveTimeOptimizerModule() {
  const [inputText, setInputText] = useState('');
  const [parsedInput, setParsedInput] = useState<DriveTimeOptimizerInput | null>(null);
  const [error, setError] = useState<string | null>(null);

  const [runQuery, { data, loading }] = useLazyQuery<DriveTimeOptimizerQuery>(DRIVE_TIME_OPTIMIZER_QUERY);

  const handleRunClick = () => {
    try {
      
      const parsed = JSON.parse(inputText);
      setParsedInput(parsed);
      runQuery({ variables: { input: parsed } });
      setError(null);
    } catch (err) {
      setError(`Invalid JSON input: ${err}`);
    }
  };

  const subtitle = "";

  return (
    <>
      <div style={{ marginBottom: '1rem', marginTop: '1rem' }}>
        <textarea
          rows={10}
          style={{ width: '100%', fontFamily: 'monospace' }}
          value={inputText}
          onChange={(e) => setInputText(e.target.value)}
          placeholder="Paste DriveTimeOptimizerInput JSON here"
        />
        <button onClick={handleRunClick}>Run Query</button>
        {error && <div style={{ color: 'red' }}>{error}</div>}
      </div>

      <JsonViewScreen title="Input" subtitle={subtitle} data={JSON.stringify(parsedInput)} loading={false} />
      <JsonViewScreen title="Result" subtitle={subtitle} data={JSON.stringify(data?.driveTimeOptimizer?.assignments) || "{}"} loading={loading} />
      <JsonViewScreen title="Skipped" subtitle={subtitle} data={JSON.stringify(data?.driveTimeOptimizer?.skipped) || "{}"} loading={loading} />
      <JsonViewScreen title="Data" subtitle={subtitle} data={data?.driveTimeOptimizer?.optimizerLogData || "{}"} loading={loading} />
    </>
  );
}
